import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import 'conditional?if=quoteandbind_lob&equals=pa!edge/quoteandbind/pa/app';
import 'conditional?if=quoteandbind_lob&equals=ho!edge/quoteandbind/ho/app';
import 'conditional?if=quoteandbind_lob&equals=cp!edge/quoteandbind/cp/app';
import 'conditional?if=quoteandbind_lob&equals=bop!edge/quoteandbind/bop/app';
import 'conditional?if=quoteandbind_lob&equals=cpp!ama/edge/quoteandbind/cpp/app';

var lobModules = [];

if (!ApplicationFeatures.hasFeature('role.vendor')) {
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.pa')) {
        lobModules.push('edge.quoteandbind.pa.app');
    }
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.ho')) {
        lobModules.push('edge.quoteandbind.ho.app');
    }
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.cp')) {
        lobModules.push('edge.quoteandbind.cp.app');
    }
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.bop')) {
        console.log('loading bop...');
        lobModules.push('edge.quoteandbind.bop.app');
    }
    if (ApplicationFeatures.hasFeature('quoteandbind_lob.cpp')) {
        lobModules.push('ama.edge.quoteandbind.cpp.app');
    }
}

export default lobModules;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/integration/quoteandbind/SupportedLobModules.js
// module id = 864
// module chunks = 0